/**
 * @module root/shared
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
export const WORKFLOW = {
  EXISTING_BYOD: 'existingBYOD',
  BYOD_PORT_IN: 'byodPortIN',
  RETURN_POSTVOID_WORKFLOW_TYPE: 'ReturnPostVoid',
  FRAUD_CHECK: 'fraudCheck',
  BILLING: 'Billing',
  NEW_FAN: 'newFan',
};
